import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oracleIam = defineConnector({
  identifier: "oracleIam",
  name: "Oracle IAM",
  tagLine: "Identity and access management",
  logo,
  protocol: "http",
  tags: ["identity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.identity\\.oraclecloud\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your Oracle IAM API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to your Oracle Cloud console
2. Navigate to **Identity & Security › Domains**
3. Create a confidential application and generate a client ID and secret
4. Grant the application the required IAM admin scopes`,
        },
      ],
    },
    {
      title: "Enter your Oracle IAM details",
      items: [
        {
          kind: "baseUrl",
          label: "Domain URL",
          required: true,
          placeholder: "https://idcs-abcd1234.identity.oraclecloud.com",
          target: { kind: "configuration", field: "domainUrl" },
          helperText:
            "Your Oracle IAM domain URL (e.g., https://idcs-abcd1234.identity.oraclecloud.com).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ domainUrl }) => `${domainUrl}/oauth2/v1/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => ["urn:opc:idm:__myscopes__"],
  },
  connectionTest: {
    protocol: "http",
    request: ({ domainUrl }) => `${domainUrl}/admin/v1/Me`,
  },
});
